import { key } from 'piqure';
import type { UsersRepository } from '@/supporting/account/domain/UsersRepository.ts';

export const USERS_REPOSITORY = key<UsersRepository>('UsersRepository');
